// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-file-inspection-collapse {
  padding: 20px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

.case-file-inspection-collapse-button {
  width: 30px;
  height: 30px;
  font-size: 20px;
}

.case-file-inspection-group-item-value {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/edozvola/case-file-inspection/case-file-inspection.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,4EAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".case-file-inspection-collapse {\n  padding: 20px;\n  background-color: white;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n}\n\n.case-file-inspection-collapse-button {\n  width: 30px;\n  height: 30px;\n  font-size: 20px;\n}\n\n.case-file-inspection-group-item-value {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
